import { facturaGradient } from "../../facturasStyles";
import ThemedElement from "shared/components/ThemedElement";
import React from "react";
import PropTypes from "prop-types";
import { Card, Grid, Tabs, Tab, Box, Paper } from "@mui/material";
import {
  ReceiptLong as ReceiptLongIcon,
  CloudUpload as CloudUploadIcon,
  ListAlt as ListAltIcon,
  HelpOutline as HelpOutlineIcon,
} from "@mui/icons-material";

import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import TableFacturasContent from "../TableFacturas"; // Cambiar el import
import FormFacturas from "../Form/FormFacturas";

const HeaderFacturas = ({ refreshFlag, onError }) => {
  const [activeTab, setActiveTab] = React.useState(1);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleImportSuccess = () => {
    if (window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent("refreshFacturas"));
    }
  };

  // Configuración de los tabs
  const tabsConfig = [
    {
      label: "Importar Facturas",
      icon: <CloudUploadIcon sx={{ fontSize: 20, mr: 1 }} />,
      value: 0,
    },
    {
      label: "Lista de Facturas",
      icon: <ListAltIcon sx={{ fontSize: 20, mr: 1 }} />,
      value: 1,
    },
    {
      label: "Instrucciones",
      icon: <HelpOutlineIcon sx={{ fontSize: 20, mr: 1 }} />,
      value: 2,
    },
  ];

  // Colores de la marca
  const colors = {
    primary: "#1e293b",
    secondary: "#0b4f6c",
    light: "#dbe5eb",
    black: "#000000",
    white: "#ffffff",
    gray: "#f5f5f5",
    darkGray: "#333333",
  };

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card
        sx={{
          mt: 1,
          mx: 3,
          py: 3,
          px: 3,
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}
      >
        {/* Header con gradiente en verde */}
        <Box
          sx={{
            background: facturaGradient,
            margin: -3,
            marginBottom: 3,
            padding: 3,
            borderBottom: `1px solid ${colors.light}`,
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            <Grid item sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <ReceiptLongIcon sx={{ color: "#fff", fontSize: 26 }} />
              <Box>
                <MDTypography
                  variant="h5"
                  fontWeight="bold"
                  sx={{
                    color: colors.white,
                  }}
                >
                  Gestión de Facturas
                </MDTypography>
                <MDTypography
                  variant="body2"
                  sx={{ color: "rgba(255,255,255,0.8)", mt: 0.5, fontSize: 13 }}
                >
                  Importe y administre las facturas del sistema financiero
                </MDTypography>
              </Box>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Box>

        {/* Tabs personalizados con colores de marca */}
        <Box sx={{ mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-indicator": {
                height: 3,
                borderRadius: "3px 3px 0 0",
                backgroundColor: colors.secondary,
              },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.875rem",
                minHeight: 48,
                transition: "all 0.2s",
                color: colors.darkGray,
                "&:hover": {
                  backgroundColor: "rgba(11,79,108,0.06)",
                  borderRadius: 1,
                  color: colors.secondary,
                },
                "&.Mui-selected": {
                  color: colors.secondary,
                },
              },
            }}
          >
            {tabsConfig.map((tab) => (
              <Tab
                key={tab.value}
                icon={tab.icon}
                label={tab.label}
                iconPosition="start"
                sx={{
                  "& .MuiTab-iconWrapper": {
                    transition: "transform 0.2s",
                  },
                  "&:hover .MuiTab-iconWrapper": {
                    transform: "scale(1.05)",
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>

        {/* Contenido de los panels */}
        <Box sx={{ mt: 2 }}>
          {/* Panel de Importación */}
          {activeTab === 0 && (
            <Box
              sx={{
                animation: "fadeIn 0.3s ease-in-out",
                "@keyframes fadeIn": {
                  "0%": { opacity: 0, transform: "translateY(10px)" },
                  "100%": { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <FormFacturas onImportSuccess={handleImportSuccess} onError={onError} />
            </Box>
          )}

          {/* Panel de Lista de Facturas */}
          {activeTab === 1 && (
            <Box
              sx={{
                animation: "fadeIn 0.3s ease-in-out",
                "@keyframes fadeIn": {
                  "0%": { opacity: 0, transform: "translateY(10px)" },
                  "100%": { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <TableFacturasContent refreshFlag={refreshFlag} onError={onError} />{" "}
              {/* Cambiar el nombre del componente */}
            </Box>
          )}

          {/* Panel de Instrucciones */}
          {activeTab === 2 && (
            <Box
              sx={{
                animation: "fadeIn 0.3s ease-in-out",
                "@keyframes fadeIn": {
                  "0%": { opacity: 0, transform: "translateY(10px)" },
                  "100%": { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  background: colors.gray,
                  borderRadius: 3,
                  border: `1px solid ${colors.light}`,
                }}
              >
                {/* Encabezado de instrucciones */}
                <Box display="flex" alignItems="center" gap={2} mb={3}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      background: facturaGradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <HelpOutlineIcon sx={{ color: colors.white, fontSize: 28 }} />
                  </Box>
                  <Box>
                    <MDTypography variant="h5" fontWeight="bold" sx={{ color: colors.primary }}>
                      Guía de Importación
                    </MDTypography>
                    <MDTypography variant="caption" sx={{ color: "text.secondary" }}>
                      Siga estos pasos para importar facturas correctamente
                    </MDTypography>
                  </Box>
                </Box>

                {/* Pasos de importación */}
                <Box sx={{ mb: 3 }}>
                  <MDTypography
                    variant="subtitle1"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ color: colors.primary }}
                  >
                    📋 Pasos a seguir:
                  </MDTypography>
                  <Box component="ol" sx={{ margin: 0, paddingLeft: "1.5rem", mt: 1 }}>
                    {[
                      "Prepare un archivo Excel (.xlsx) con las siguientes columnas:",
                      "Haga clic en el área de selección para elegir el archivo",
                      "Verifique que el archivo seleccionado sea correcto",
                      "Presione el botón 'Procesar Facturas'",
                      "Espere la confirmación de procesamiento",
                    ].map((step, index) => (
                      <Box
                        key={index}
                        component="li"
                        sx={{
                          mb: 1.5,
                          color: colors.darkGray,
                          "&::marker": {
                            color: colors.secondary,
                            fontWeight: "bold",
                          },
                        }}
                      >
                        <MDTypography variant="body2">
                          {step}
                          {index === 0 && (
                            <Box
                              component="ul"
                              sx={{ margin: 0.5, paddingLeft: "1.5rem", mt: 0.5 }}
                            >
                              <li>
                                <strong># Factura</strong> - Número de Factura (requerido)
                              </li>
                              <li>
                                <strong>NIT</strong> - Número de identificación tributaria
                                (requerido)
                              </li>
                              <li>
                                <strong>Empresa</strong> - Nombre de la empresa (requerido)
                              </li>
                              <li>
                                <strong>Valor</strong> - Monto de la factura (requerido)
                              </li>
                              <li>
                                <ThemedElement
                                  component="strong"
                                  style={{ color: colors.secondary }}
                                >
                                  Código / Code
                                </ThemedElement>{" "}
                                - Código empresarial (requerido)
                                <MDTypography
                                  component="span"
                                  variant="caption"
                                  sx={{ display: "block", ml: 2, color: colors.primary }}
                                >
                                  ℹ️ Este campo es requerido y se mostrará como &quot;Código
                                  Empresarial&quot; en la tabla
                                </MDTypography>
                              </li>
                            </Box>
                          )}
                        </MDTypography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Notas importantes */}
                <Box
                  sx={{
                    bgcolor: "#e8f5e9",
                    borderRadius: 2,
                    p: 2,
                    border: `1px solid ${colors.light}`,
                    mb: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Box sx={{ fontSize: 20 }}>💡</Box>
                    <MDTypography
                      variant="subtitle2"
                      fontWeight="bold"
                      sx={{ color: colors.secondary }}
                    >
                      Notas importantes:
                    </MDTypography>
                  </Box>
                  <MDTypography variant="body2" sx={{ color: "text.secondary" }}>
                    • Las facturas se importarán con estado <strong>&quot;pendiente&quot;</strong>{" "}
                    por defecto
                  </MDTypography>
                  <MDTypography variant="body2" sx={{ color: "text.secondary" }}>
                    • El campo <strong>&quot;Código Empresarial&quot;</strong> es{" "}
                    <ThemedElement component="strong" style={{ color: colors.error }}>
                      OBLIGATORIO
                    </ThemedElement>
                  </MDTypography>
                  <MDTypography variant="body2" sx={{ color: "text.secondary" }}>
                    • El archivo no debe exceder los 10MB de tamaño
                  </MDTypography>
                  <MDTypography variant="body2" sx={{ color: "text.secondary" }}>
                    • Desde la tabla puede editar todos los campos, incluyendo el código empresarial
                  </MDTypography>
                </Box>

                {/* Requisitos técnicos */}
                <Box
                  sx={{
                    bgcolor: "#e8f5e9",
                    borderRadius: 2,
                    p: 2,
                    border: `1px solid ${colors.light}`,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Box sx={{ fontSize: 20 }}>✅</Box>
                    <MDTypography
                      variant="subtitle2"
                      fontWeight="bold"
                      sx={{ color: colors.secondary }}
                    >
                      Requisitos del archivo:
                    </MDTypography>
                  </Box>
                  <MDTypography variant="caption" component="div" sx={{ color: "text.secondary" }}>
                    <ul style={{ margin: 0, paddingLeft: "1.5rem" }}>
                      <li>Formato: .xlsx (Excel 2007 o superior)</li>
                      <li>Columnas requeridas: # Factura, NIT, Empresa, Valor, Código</li>
                      <li>
                        La columna{" "}
                        <ThemedElement component="strong" style={{ color: colors.secondary }}>
                          Código
                        </ThemedElement>{" "}
                        o{" "}
                        <ThemedElement component="strong" style={{ color: colors.secondary }}>
                          Code
                        </ThemedElement>{" "}
                        es obligatoria
                      </li>
                      <li>Sin filas vacías en los datos principales</li>
                      <li>Formato numérico para la columna Valor</li>
                    </ul>
                  </MDTypography>
                </Box>

                {/* Ejemplo de formato */}
                <Box
                  sx={{
                    bgcolor: "#fff8e1",
                    borderRadius: 2,
                    p: 2,
                    border: `1px solid #ffe082`,
                    mt: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Box sx={{ fontSize: 20 }}>📊</Box>
                    <MDTypography variant="subtitle2" fontWeight="bold" color="#ed6c02">
                      Ejemplo de formato:
                    </MDTypography>
                  </Box>
                  <MDTypography
                    variant="caption"
                    component="div"
                    sx={{ color: "text.secondary", fontFamily: "monospace" }}
                  >
                    <ThemedElement
                      component="table"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <ThemedElement
                          component="tr"
                          style={{ backgroundColor: colors.light, color: colors.white }}
                        >
                          <th style={{ padding: "8px", textAlign: "left" }}># Factura</th>
                          <th style={{ padding: "8px", textAlign: "left" }}>NIT</th>
                          <th style={{ padding: "8px", textAlign: "left" }}>Empresa</th>
                          <th style={{ padding: "8px", textAlign: "left" }}>Valor</th>
                          <th style={{ padding: "8px", textAlign: "left" }}>Código</th>
                        </ThemedElement>
                      </thead>
                      <tbody>
                        <tr>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            FAC-001
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            900123456
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            Empresa SAS
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            1500000
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            EMP-001
                          </ThemedElement>
                        </tr>
                        <tr>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            FAC-002
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            987654321
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            Otra Empresa
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            2500000
                          </ThemedElement>
                          <ThemedElement
                            component="td"
                            style={{ padding: "8px", borderBottom: "1px solid #ddd" }}
                          >
                            EMP-002
                          </ThemedElement>
                        </tr>
                      </tbody>
                    </ThemedElement>
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    sx={{ color: "text.secondary", mt: 1, display: "block" }}
                  >
                    ℹ️ La columna &quot;Código&quot; es{" "}
                    <ThemedElement component="strong" style={{ color: colors.error }}>
                      OBLIGATORIA
                    </ThemedElement>
                    . Todas las filas deben tener un código empresarial.
                  </MDTypography>
                </Box>

                {/* Versión y ayuda */}
                <Box
                  sx={{
                    mt: 3,
                    pt: 2,
                    borderTop: `1px solid ${colors.light}`,
                    textAlign: "center",
                  }}
                >
                  <MDTypography
                    variant="caption"
                    sx={{ color: "text.secondary", fontSize: "0.7rem" }}
                  >
                    Sistema de Gestión de Facturas v1.0 | Para soporte contacte al administrador
                  </MDTypography>
                </Box>
              </Paper>
            </Box>
          )}
        </Box>
      </Card>
    </MDBox>
  );
};

HeaderFacturas.defaultProps = {
  refreshFlag: false,
  onError: null,
};

HeaderFacturas.propTypes = {
  refreshFlag: PropTypes.bool,
  onError: PropTypes.func,
};

export default HeaderFacturas;
